/*
**************************** 
홈페이지 유저 정보 변경
*****************************
*/

import axios from "axios";
import React, { useEffect, useState } from "react";
import PopupDom from "./PopupDom";
import ProfileNewPassword from "./ProfileNewPassword";

export default function ProfileChange(props) {
    const [userData, setUserData] = useState({ username: "", name: "", login_id: "", email: "", phone: "", address: "", subAddress: "", password: "" });
    const [changeData, setChangeData] = useState({});

    const setFunc = (changeData) => {
        let copyChangeData = { ...changeData };
        copyChangeData = changeData;
        setChangeData(copyChangeData);
    };

    useEffect(() => {
        if (props.data !== undefined && userData.username === "") {
            setAddress(props.data.address);
            setUserData(props.data);
        }
    });

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const openPostCode = function () {
        setIsPopupOpen(true);
    }
    const closePostCode = function () {
        setIsPopupOpen(false);
    }

    const submit = async function (event) {
        event.preventDefault();
        const userName = event.target.userName.value;
        const email = event.target.email.value;
        const phone = event.target.phone.value;

        const _address = event.target.address.value;
        const subAddress = event.target.subAddress.value;

        const userId = sessionStorage.getItem("userId");

        const reqSql = "./api/users/user/" + Number(userId);
        const params = { userName, email, phone, _address, subAddress };
        await axios.post(reqSql, params, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.status === 200 || res.status === 201) {
                alert("회원정보가 수정 되었습니다. 메인으로 이동합니다.");
                window.location.href = "/";
            } else {
                if (res.status === 409) {
                    alert("등록된 아이디입니다.");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            alert("회원정보 수정 도중 오류가 발생하였습니다.");
        });
    }

    const [address, setAddress] = useState("");

    const callBackAddress = function (address) {
        setAddress(address);
    }
    return (
        <div>
            <div>
                <div className="modal fade" id="profileChange" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">회원정보수정</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="sign-up">
                                    <form action="#" onSubmit={submit} >
                                        <div className="form-group text-start">
                                            <label htmlFor="userName" className="form-label mt-4">이름:</label>
                                            <input type="text" className="form-control" placeholder="이름을 입력해 주세요" name="userName" defaultValue={userData.username || ''} onChange={(e) => {
                                                let copyUserData = { ...userData, username: e.value };
                                                setUserData(copyUserData);
                                            }} required></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="loginId" className="form-label mt-4">아이디:</label>
                                            <input type="text" className="form-control" placeholder="아이디를 입력해 주세요" name="login_id" defaultValue={userData.login_id || ''} onChange={(e) => {
                                                let copyUserData = { ...userData, login_id: e.value };
                                                setUserData(copyUserData);
                                            }} required></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="email" className="form-label mt-4">이메일:</label>
                                            <input type="email" className="form-control" placeholder="이메일을 입력해 주세요" name="email" defaultValue={userData.email || ''} onChange={(e) => {
                                                let copyUserData = { ...userData, email: e.value };
                                                setUserData(copyUserData);
                                            }} required></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="phone" className="form-label mt-4">전화번호:</label>
                                            <input type="tel" className="form-control" placeholder="전화번호를 입력해 주세요" name="phone" defaultValue={userData.phone || ''} onChange={(e) => {
                                                let copyUserData = { ...userData, phone: e.value };
                                                setUserData(copyUserData)
                                            }} required></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="address" className="form-label mt-4">주소:</label><span><button type="button" className="btn btn-info small m-2" onClick={() => {
                                                openPostCode();
                                            }}>우편번호 검색</button></span>
                                            <input type="text" className="form-control" placeholder="주소를 입력해 주세요" name="address" defaultValue={address || ''} onChange={(e) => {
                                                let copyUserData = { ...userData, address: e.value };
                                                setUserData(copyUserData)
                                            }} required></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="subAddress" className="form-label mt-4">상세 주소:</label>
                                            <input type="text" className="form-control" placeholder="상세 주소를 입력해 주세요" name="subAddress" defaultValue={userData.subAddress || ''} onChange={(e) => {
                                                let copyUserData = { ...userData, subAddress: e.value };
                                                setUserData(copyUserData);
                                            }}></input>
                                        </div>
                                        <div className="form-group mt-4 row p-2">
                                            <button type="submit" className="btn btn-lg btn-primary" onClick={(e) => {
                                            }}>수정등록</button>
                                            <div className="form-group text-start">
                                            </div>
                                            <button type="button" className="btn btn-lg btn-primary mt-3" data-bs-toggle="modal" data-bs-target="#profileNewPassword" onClick={() => {
                                                const changeData = { id: Number(sessionStorage.getItem("userId")), login_id: userData.login_id };
                                                setFunc(changeData);
                                            }}>비밀번호변경</button>
                                        </div>
                                    </form>
                                    <div>
                                        {isPopupOpen === true ? <PopupDom open={true} close={closePostCode} header="우편번호 검색" onClose={closePostCode} dataCall={callBackAddress}></PopupDom> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ProfileNewPassword changeData={changeData}></ProfileNewPassword>
        </div>
    )
}